import { Message, Modal } from "view-design";
import $fn from "./fn";
import {
  getNormalizedUrl,
  isFileUploadRequest,
  extractMetaData,
  buildRequestPath,
  getRequestBody,
  toSignV3,
} from "./toSignV3";
const blankUrls = ["/box_serverlist", ".txt", "/box/server/pc_list"];

//Ajax-JSON函数
//强制为同步模式
function AjaxJson(url, method, args, fn, dataType) {
  var obj = null;
  var ajax = new AjaxObject();
  ajax.URL = url;
  ajax.dataType = dataType;
  ajax.Method = method;
  ajax.Async = true;
  ajax.Args = args;
  ajax.onSuccess = function (xhr) {
    var text = xhr.responseText;
    if (text.charCodeAt() == 65279) text = text.substring(1); //处理utf8引导字节
    eval("obj=" + text);
    fn(obj, xhr);
  };
  ajax.onFailure = function (xhr) {
    var text = xhr.responseText;
    if (text.charCodeAt() == 65279) text = text.substring(1); //处理utf8引导字节
    eval("obj=" + text);
    fn(obj, xhr);
  };
  ajax.Connect();
  return obj;
}

const appvNumber = process.env.VUE_APP_VERSION
  ? process.env.VUE_APP_VERSION
  : "1.0.0";
const deviceNumber = "web";
let signParams = {
  appv: appvNumber,
  device: deviceNumber,
  deviceId: "",
  isEmbedded: false,
  embedded: "web",
};

//Ajax标准类模块
function AjaxObject() {
  this.URL = "";
  this.Method = "GET";
  this.Async = true;
  this.Args = null;
  this.onSuccess = function () {};
  this.onFailure = function () {};
  this.Request = window.XMLHttpRequest
    ? new XMLHttpRequest()
    : new ActiveXObject("Microsoft.XMLHTTP");

  if (!AjaxObject.requestInterceptors) {
    AjaxObject.requestInterceptors = [];
  }

  AjaxObject.useRequestInterceptor = function (interceptor) {
    this.requestInterceptors.push(interceptor);
  };
  // 执行拦截器链
  this.runInterceptors = async function (config) {
    for (let interceptor of AjaxObject.requestInterceptors) {
      config = await interceptor(config);
    }
    return config;
  };

  this.Connect = function () {
    this.Method = this.Method.toUpperCase();
    // 请求拦截器参数
    const config = {
      url: this.URL,
      method: this.Method,
      args: this.Args,
      dataType: this.dataType,
      headers: {},
    };

    this.runInterceptors(config).then(async (finalConfig) => {
      // 验签配置
      const originalData = JSON.parse(JSON.stringify(finalConfig.args || ""));
      // const url = getNormalizedUrl(finalConfig.url);
      // 构造请求绝对地址（包含查询参数）
      const requestPath = buildRequestPath(
        getNormalizedUrl(finalConfig.url),
        finalConfig.params || {},
        finalConfig.method,
      );
      const token = "";

      const newSignObj = {
        method: finalConfig.method || "",
        url:
          finalConfig.method === "GET"
            ? decodeURIComponent(requestPath) || ""
            : requestPath || "",
        deviceType: deviceNumber, //设备类型
        deviceId: "",
        appv: appvNumber,
        token: token || "",
      };

      if (this.Method == "GET" && this.Args) {
        this.Request.open(this.Method, this.URL, this.Async);
        if (this.dataType == "json") {
          this.Request.setRequestHeader(
            "Content-type",
            "application/json;charset=UTF-8",
          );
        } else {
          this.Request.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded;",
          );
        }
        var args = "";
        if (typeof this.Args == "object") {
          // 增加sign验签参数
          this.Args = $fn.toSign(this.Args, this.URL);
          var arr = new Array();
          for (var k in this.Args) {
            var v = this.Args[k];
            arr.push(k + "=" + v);
          }
          args = arr.join("&");
          this.URL += (this.URL.indexOf("?") == -1 ? "?" : "&") + args;
          this.Args = null;
        }
        newSignObj.url += (requestPath.indexOf("?") == -1 ? "?" : "&") + args;
        const isBlank = blankUrls.some(
          (url) => finalConfig.url && finalConfig.url.includes(url),
        );
        if (!isBlank && $fn.getBoxVersion(appvNumber) >= 501) {
          // GET请求的请求体为空字符串，查询参数已经在signObj.url 中（通过 buildRequestPath 处理）
          finalConfig.headers["X-BOX-AUTHORIZATION"] = await toSignV3(
            {},
            newSignObj,
          );
        }
      }
      var q = this.Request;
      var evt1 = this.onSuccess;
      var evt2 = this.onFailure;
      var evt3 = this.onLoadend;
      this.Request.onreadystatechange = function () {
        _onStateChange(q, evt1, evt2, evt3);
      };

      this.Request.open(this.Method, this.URL, this.Async);
      if (
        this.URL.indexOf("/box_serverlist") < 0 &&
        this.URL.indexOf("down_url.json") < 0
      ) {
        // this.Request.setRequestHeader(
        //   "token",
        //   $fn.cookies.getToken("token")
        // );
        if (this.URL.indexOf("/FindGame/getGameListWithRank") < 0) {
          this.Request.setRequestHeader("device", "web");
        } else {
          this.Request.setRequestHeader("device", "pc");
        }
        if (this.URL.indexOf("/box/v1") >= 0) {
          this.Request.setRequestHeader("appv", appvNumber);
        } else {
          this.Request.setRequestHeader("appv", "1.0.0");
        }
      }
      if (
        this.Method == "POST" ||
        this.Method == "PUT" ||
        this.Method == "DELETE"
      ) {
        if (this.dataType == "json") {
          this.Request.setRequestHeader(
            "Content-type",
            "application/json;charset=UTF-8",
          );
        } else {
          this.Request.setRequestHeader(
            "Content-type",
            "application/x-www-form-urlencoded;",
          );
        }
        let args = "";
        if (typeof this.Args == "string") {
          args = this.Args;
        } else if (typeof this.Args == "object") {
          // 增加sign验签参数
          if (this.URL.indexOf("/v1/newLog") >= 0) {
            this.Args = $fn.toCollectSign(this.Args);
          } else {
            this.Args = $fn.toSign(this.Args, this.URL);
          }
          if (this.dataType == "json") {
            this.Args = JSON.stringify(this.Args);
          } else {
            let arr = new Array();
            for (let k in this.Args) {
              let v = this.Args[k];
              arr.push(k + "=" + v);
            }
            args = arr.join("&");
            this.Args = encodeURI(args);
          }
        }
        if (finalConfig.method === "POST") {
          // 如果是文件上传，需要提取metaData 对象
          const isFileUpload = isFileUploadRequest({
            ...finalConfig,
            data: this.Args,
          });
          const requestBodyStr = getRequestBody(this.Args, isFileUpload);
          if ($fn.getBoxVersion() >= 501) {
            finalConfig.headers["X-BOX-AUTHORIZATION"] = await toSignV3(
              requestBodyStr,
              newSignObj,
            );
          }
        }
      }
      // 添加拦截器自定义 header
      if (finalConfig.headers) {
        for (let key in finalConfig.headers) {
          this.Request.setRequestHeader(key, finalConfig.headers[key]);
        }
      }

      try {
        this.Request.send(this.Args);
      } catch (e) {
        console.log("connect exception.");
      }
    });
  };

  function _onStateChange(xhr, success, failure) {
    if (xhr.readyState == 4) {
      var s = xhr.status;
      if (s == 0) {
        console.log("connect to url failure.");
      } else if (s >= 200 && s < 400) {
        success(xhr);
      } else {
        failure(xhr);
      }
    }
  }
}

class http {
  constructor() {}

  originPost(obj, fn) {
    if (obj.json !== undefined) {
      AjaxJson(obj.url, "post", obj.json, fn, "json");
    } else {
      AjaxJson(obj.url, "post", obj.data, fn);
    }
  }
  originGet(obj, fn) {
    if (obj.json !== undefined) {
      AjaxJson(obj.url, "get", obj.json, fn, "json");
    } else {
      AjaxJson(obj.url, "get", obj.data, fn);
    }
  }
  originPut(obj, fn) {
    if (obj.json !== undefined) {
      AjaxJson(obj.url, "put", obj.json, fn, "json");
    } else {
      AjaxJson(obj.url, "put", obj.data, fn);
    }
  }
  originDelete(obj, fn) {
    if (obj.json !== undefined) {
      AjaxJson(obj.url, "delete", obj.json, fn, "json");
    } else {
      AjaxJson(obj.url, "delete", obj.data, fn);
    }
  }
  httpPost(obj) {
    return new Promise((resolve) => {
      this.originPost(obj, (res) => {
        resolve(res);
      });
    });
  }
  httpGet(obj) {
    return new Promise((resolve) => {
      this.originGet(obj, (res) => {
        resolve(res);
      });
    });
  }
  httpPut(obj) {
    return new Promise((resolve) => {
      this.originPut(obj, (res) => {
        resolve(res);
      });
    });
  }
  httpDelete(obj) {
    return new Promise((resolve) => {
      this.originDelete(obj, (res) => {
        resolve(res);
      });
    });
  }
  // axiosGet(obj) {
  //     return new Promise(resolve => {
  //         originAxiosGet(obj, res => {
  //             resolve(res);
  //         });
  //     });
  // }
}

export default new http();
